import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../../components/InnerHero";
import { QuickFactsCard } from "./CampusLifePageParts";
import { hostelRules } from "./hostelRulesData";

const hostel = {
  name: "Girls Hostel",
  description:
    "KLS VDIT provides safe, comfortable, and well-equipped accommodation through Girls Hostel 1 and Girls Hostel 2, ensuring a conducive environment for academic and personal growth.",

  dashboard: [
    ["Total Hostels", "2"],
    ["Total Rooms", "104"],
    ["Capacity", "247"],
    ["Occupied", "210"],
  ],

  facilities: [
    "RO drinking water facility (25 litres/hour)",
    "80-litre water coolers",
    "Geysers and water dispensers",
    "Induction cooktops",
    "Dedicated 500 Mbps internet connectivity",
    "Incinerator machine in each hostel",
    "Mini gym in both hostels",
    "Indoor and outdoor sports facilities",
    "Medical facilities",
    "Newspapers and TV room",
    "Electricity backup facility",
    "24x7 CCTV surveillance",
  ],

  hostelTeam: {
    staffInCharge: [
      "Mrs. Poornima Raikar",
      "Mrs. Shree Gowri S. S.",
    ],
    warden: "Mrs. Madhuri M. Walvekar",
  },

  overview:
    "The Girls Hostels at KLS VDIT are designed to provide a secure, hygienic, and student-friendly living environment with modern amenities that support both academic excellence and overall well-being.",
};

const quickFacts = [
  ["Category", "Campus Life"],
  ["Facility", hostel.name],
  ["Total Hostels", "2"],
  ["Total Rooms", "104"],
  ["Capacity", "247"],
  ["Occupied", "210"],
  ["Warden", hostel.hostelTeam.warden],
];

const facilityImages = [
  // "1.jpeg",
  // "2.jpeg",
  "3.jpeg",
  "4.jpeg",
  "5.jpeg",
  "6.jpeg",
  "7.jpeg",
  "8.jpeg",
  "10.jpg",
  "11.jpg",
  "12.jpg",
  "13.jpg",
].map((filename, index) => ({
  src: `/Girls-Hostel-Facilities/${filename}`,
  alt: `Girls Hostel facility ${index + 1}`,
}));

const GirlsHostel = () => {
  return (
    <main>
      <InnerHero
        title={hostel.name}
        image="/Campus/girlHostel.png"
        breadcrumbs={[
          { label: "Campus Life", to: "/campus" },
          { label: "Hostels", to: "/campus-life/hostels" },
          { label: hostel.name },
        ]}
      />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10 items-start">
        <section className="lg:col-span-2">
          <Link
            to="/campus-life/hostels"
            className="inline-flex items-center gap-2 text-sm text-brand font-semibold hover:underline mb-6"
          >
            Back to Hostels
          </Link>

        <h2
          className="text-3xl md:text-4xl text-brand font-semibold mb-5"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {hostel.name}
        </h2>
        <p className="text-[#2a2a2a]/85 leading-relaxed text-[16px] max-w-4xl">
          {hostel.description}
        </p>
        <p className="text-[#2a2a2a]/85 leading-relaxed text-[16px] max-w-4xl mt-4">
          {hostel.overview}
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-8">
          {hostel.dashboard.map(([label, value]) => (
            <div key={label} className="bg-brand border border-brand p-5 min-h-[90px] flex flex-col justify-center">
              <p
                className="text-2xl text-white font-semibold leading-none"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {value}
              </p>
              <p className="text-xs uppercase tracking-[0.16em] text-white font-sans-ui font-semibold mt-3">
                {label}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <h3 className="text-xl text-brand font-semibold">Girls Hostel Facilities</h3>
          <div className="grid md:grid-cols-2 gap-5 mt-4">
            {facilityImages.map(({ src, alt }) => (
              <figure
                key={src}
                className="bg-white border border-brand/15 overflow-hidden"
              >
                <img
                  src={src}
                  alt={alt}
                  className="w-full aspect-[16/10] object-cover"
                  loading="lazy"
                />
              </figure>
            ))}
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mt-10">
          <div className="bg-white border border-brand/15 p-5">
            <h3 className="text-xl text-brand font-semibold">Facilities</h3>
            <ul className="list-disc pl-5 mt-3 space-y-2 text-[#2a2a2a]/85">
              {hostel.facilities.map((facility) => (
                <li key={facility}>{facility}</li>
              ))}
            </ul>
          </div>

          <div className="bg-white border border-brand/15 p-5">
            <h3 className="text-xl text-brand font-semibold">Hostel Team</h3>
            <div className="mt-3 space-y-4 text-[#2a2a2a]/85">
              <div>
                <div>
                <p className="text-sm uppercase tracking-widest text-brand font-semibold">
                  Warden
                </p>
                <p className="mt-2">{hostel.hostelTeam.warden}</p>
              </div>
                <p className="text-sm uppercase tracking-widest text-brand font-semibold">
                  Staff In-charge
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  {hostel.hostelTeam.staffInCharge.map((member) => (
                    <li key={member}>{member}</li>
                  ))}
                </ul>
              </div>
              
            </div>
          </div>
        </div>

        <div className="bg-white border border-brand/15 p-5 mt-8">
          <h3 className="text-xl text-brand font-semibold">Rules and Regulations</h3>
          <ol className="list-decimal pl-5 mt-3 space-y-2 text-[#2a2a2a]/85">
            {hostelRules.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ol>
        </div>
        </section>

        <aside className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36">
          <QuickFactsCard facts={quickFacts} />
        </aside>
      </div>
      </section>
    </main>
  );
};

export default GirlsHostel;